
import Icon from '../../../components/AppIcon';

const UserListItem = ({ user, isSelected, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'inactive':
        return 'bg-muted text-muted-foreground';
      case 'suspended':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'Admin':
        return 'bg-error/10 text-error';
      case 'Ops':
        return 'bg-primary/10 text-primary';
      case 'Finance':
        return 'bg-accent/10 text-accent';
      case 'RNR':
        return 'bg-warning/10 text-warning';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatLastLogin = (date) => {
    const now = new Date();
    const loginDate = new Date(date);
    const diffMs = now - loginDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return loginDate?.toLocaleDateString('en-GB');
  };

  return (
    <div
      onClick={onClick}
      className={`p-4 border-b border-border cursor-pointer transition-all duration-150 hover:bg-accent/5 ${
        isSelected ? 'bg-primary/5 border-l-4 border-l-primary' : ''
      }`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-sm font-semibold text-primary">
              {user?.name?.split(' ')?.map((n) => n?.[0])?.join('')?.toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground truncate">
              {user?.name}
            </h4>
            <p className="text-xs text-muted-foreground truncate">
              {user?.email}
            </p>
          </div>
        </div>
        <span
          className={`px-2 py-1 rounded text-xs font-medium flex-shrink-0 ${getStatusColor(
            user?.status
          )}`}
        >
          {user?.status}
        </span>
      </div>
      <div className="flex items-center justify-between mt-3">
        <div className="flex items-center gap-2">
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${getRoleBadgeColor(
              user?.role
            )}`}
          >
            {user?.role}
          </span>
          {user?.department && (
            <span className="text-xs text-muted-foreground">
              {user?.department}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <Icon name="Clock" size={12} />
          <span>{formatLastLogin(user?.lastLogin)}</span>
        </div>
      </div>
      {user?.mfaEnabled && (
        <div className="flex items-center gap-1 mt-2 text-xs text-success">
          <Icon name="Shield" size={12} />
          <span>MFA Enabled</span>
        </div>
      )}
    </div>
  );
};

export default UserListItem;